import DragItemCol from 'components/common/draggable/DragItemCol';
import DragWrapperRow from 'components/common/draggable/DragWrapperRow';
import lodash from 'lodash';
import PropTypes from 'prop-types';
import React, { useEffect, useState } from 'react';
import { Spinner } from 'react-bootstrap';
import { useDispatch } from 'react-redux';
import { setImagesOrder } from 'redux/propsSlice';
import ImageDeleteModal from '../../sites/admin/inmobiliario/gestionarPropiedades/modals/imageDeleteModal';
import { ImageCard } from './ImageCard';
import './imageLayout.css';
import { UploadDragDrop } from '../../sites/admin/inmobiliario/gestionarPropiedades/common/UploadDragDrop';
import { setImagesOrderProject } from 'redux/projectsSlice';

const imgOrderObj = {
  property: setImagesOrder,
  project: setImagesOrderProject
};

export const ImagesLayout = ({
  images,
  setData,
  setStepStatus,
  data,
  uploading,
  handleImages,
  type,
  accessor,
  replaceImagesInData,
  parent
}) => {
  const dispatch = useDispatch();

  const [imageToDelete, setImageToDelete] = useState(undefined);
  const [modalDelete, setModalDelete] = useState(false);

  const [items, setItems] = useState(images);

  const [reRender, setReRender] = useState(true);

  const handleDelete = ({ filename }) => {
    setModalDelete(true);
    setImageToDelete(filename);
  };

  useEffect(async () => {
    if (data._id && items.length && !lodash.isEqual(items, images)) {
      const status = await dispatch(
        imgOrderObj[parent](
          data._id,
          items.map(image => image.filename || image.url),
          accessor
        )
      );

      if (status < 400) {
        replaceImagesInData(items, accessor);
      } else {
        setItems(images);
        setReRender(prev => !prev);
        setReRender(prev => !prev);
      }
    }
  }, [items]);

  useEffect(() => {
    if (!lodash.isEqual(items, images)) {
      setItems(images);
      setReRender(prev => !prev);
      setReRender(prev => !prev);
    }
  }, [images]);

  return (
    <>
      {reRender && (
        <DragWrapperRow
          setItems={setItems}
          options={{ draggingItemClassName: 'bg-white rounded' }}
          className="g-3"
        >
          {({ draggableClassName }) => {
            return (
              <>
                {images?.map((image, index) => (
                  <DragItemCol
                    style={{
                      aspectRatio: '1/1'
                    }}
                    key={image.filename + index}
                    draggableClassName={draggableClassName}
                    className="d-flex justify-content-center align-items-center"
                    index={index}
                    xs={12}
                    sm={6}
                    md={4}
                    lg={3}
                    xl={2}
                  >
                    <ImageCard
                      handleDelete={handleDelete}
                      image={image}
                      index={index}
                      accessor={accessor}
                      propId={data._id}
                      key={image.filename + index}
                      setData={setData}
                      parent={parent}
                    />
                  </DragItemCol>
                ))}

                {uploading && (
                  <DragItemCol
                    className="d-flex justify-content-center align-items-center"
                    style={{ aspectRatio: '1/1' }}
                    xs={12}
                    sm={6}
                    md={4}
                    lg={3}
                    xl={2}
                    index="fixed"
                  >
                    <Spinner animation="border" variant="primary" />
                  </DragItemCol>
                )}

                <DragItemCol
                  className="d-flex justify-content-center align-items-center"
                  style={{ aspectRatio: '1/1' }}
                  xs={12}
                  sm={6}
                  md={4}
                  lg={3}
                  xl={2}
                  index="fixed"
                >
                  <UploadDragDrop handleImages={handleImages} type={type} />
                </DragItemCol>
              </>
            );
          }}
        </DragWrapperRow>
      )}

      {modalDelete && (
        <ImageDeleteModal
          image={imageToDelete}
          accessor={accessor}
          setShow={setModalDelete}
          setData={setData}
          setStepStatus={setStepStatus}
          data={data}
          parent={parent}
          willBePaused={
            accessor === 'images' &&
            images.length <= 3 &&
            data.status === 'published'
          }
        />
      )}
    </>
  );
};
ImagesLayout.propTypes = {
  images: PropTypes.array.isRequired,
  setData: PropTypes.func.isRequired,
  setStepStatus: PropTypes.func.isRequired,
  data: PropTypes.object.isRequired,
  uploading: PropTypes.bool.isRequired,
  accessor: PropTypes.oneOf(['images', 'houseMaps']).isRequired,
  replaceImagesInData: PropTypes.func.isRequired,
  handleImages: PropTypes.func.isRequired,
  type: PropTypes.oneOf(['image', 'houseMap']).isRequired,
  parent: PropTypes.oneOf(['property', 'project']).isRequired
};
